function normalizeEpochMillis(value) {
  if (!Number.isFinite(value)) return 0;
  // Treat 10-digit epoch values as seconds.
  if (Math.abs(value) > 0 && Math.abs(value) < 1e11) {
    return value * 1000;
  }
  return value;
}

export function toMillis(timestamp) {
  if (timestamp == null) return 0;

  if (timestamp instanceof Date) {
    const millis = timestamp.getTime();
    return Number.isFinite(millis) ? millis : 0;
  }

  if (typeof timestamp === 'number') {
    return normalizeEpochMillis(timestamp);
  }

  if (typeof timestamp === 'string') {
    const trimmed = timestamp.trim();
    if (!trimmed) return 0;

    if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
      return normalizeEpochMillis(Number(trimmed));
    }

    const parsed = Date.parse(trimmed);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  const parsed = Date.parse(String(timestamp));
  return Number.isFinite(parsed) ? parsed : 0;
}

export function toIsoTimestamp(timestamp, fallbackMillis = Date.now()) {
  const millis = toMillis(timestamp) || fallbackMillis;
  return new Date(millis).toISOString();
}
